import { BASE_URL, fetchWithAuth } from './client';

/**
 * Accelerate report delivery by spending credits
 * @param {string} caseId - Case ID (with or without 'case-' prefix)
 * @param {string} runId - Pipeline run ID
 * @param {string} accelerationLevel - Target tier: "starter" | "pro" | "ultra"
 * @returns {Promise<AccelerateDeliveryResponse>}
 * @throws {Error} With detail message from API
 */
export async function accelerateDelivery(caseId, runId, accelerationLevel) {
    const response = await fetchWithAuth(`${BASE_URL}/api/reports/accelerate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            case_id: caseId,
            run_id: runId,
            acceleration_level: accelerationLevel
        })
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Failed to accelerate delivery');
    }

    return response.json();
}
